import { Permissions } from "models/Permissions";
import { createContext } from "react";

export interface PermissionsError {
  code?: number;
  message?: string;
}

export interface IPermissionsContext {
  permissions: Permissions | undefined;
  currentUserEmail: string;
  isAdministrator: boolean;
  isBoardOwner: boolean;
  isBoardMember: boolean;
  handleHttpError(err?: unknown): void;
  setErrorCode(errorCode: number): void;
}

export const PermissionsContext = createContext({} as IPermissionsContext);
